import React, { Component } from "react";
import { connect } from "react-redux";

import { setDuration, setPosition, setPlaying, selectPlaying, selectPosition, selectDragging } from "../../ducks/time";
import getVideoUrl from "../../modules/get-video-url";

import Styles from "./connected-video.module.scss";

class Video extends Component {

    componentDidMount() {
        requestAnimationFrame(this.handleAnimationFrame);
        this.videoElement.playbackRate = 2;
    }

    handleDurationChange = e => {
        this.props.setDuration(e.target.duration);
    };

    handleAnimationFrame = (time) => {
        if (this.props.playing) {
            this.props.setPosition(this.videoElement.currentTime);
        }
        requestAnimationFrame(this.handleAnimationFrame);
    }

    componentWillUpdate(nextProps) {
        if (nextProps.playing !== this.props.playing) {
            if (nextProps.playing) {
                this.videoElement.play();
            } else {
                this.videoElement.pause();
            }
        }
        if (nextProps.dragging && nextProps.position !== this.videoElement.currentTime) {
            this.videoElement.currentTime = nextProps.position;
        }
    }

    render() {
        const { video, setPlaying } = this.props;
        return (
            <video
                className={Styles.videoPlayer}
                ref={r => (this.videoElement = r)}
                preload="auto"
                onDurationChange={this.handleDurationChange}
                onPause={() => setPlaying(false)}
                onPlay={() => setPlaying(true)}
                onEnded={() => setPlaying(false)}
            >
                <source src={getVideoUrl(video)} type="video/mp4" />
            </video>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        playing: selectPlaying(state),
        position: selectPosition(state),
        dragging: selectDragging(state),
    };
};
const mapDispatchToProps = {
    setDuration,
    setPosition,
    setPlaying,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Video);



// WEBPACK FOOTER //
// ./src/components/connected-video/connected-video.js